import { useState, useRef, useCallback } from 'react';
import { gsap } from 'gsap';
export const useCardAnimation = (containerRef, shouldAnimate) => {
    const cardsRef = useRef([]);
    const timelineRef = useRef(null);
    const [isTransitioning, setIsTransitioning] = useState(false);
  
    const animateCards = useCallback(() => {
      if (!containerRef.current || !shouldAnimate) return;
  
      if (timelineRef.current) timelineRef.current.kill();
      if (cardsRef.current.length === 0) return;
  
      gsap.set(cardsRef.current, { autoAlpha: 0, x: 50 });
  
      timelineRef.current = gsap.timeline({
        onComplete: () => setIsTransitioning(false),
      }).to(cardsRef.current, {
        autoAlpha: 1,
        x: 0,
        duration: 0.3,
        stagger: 0.03,
        ease: "power2.out",
      });
    }, [shouldAnimate, containerRef]);
  
    const addToRefs = (el) => {
      if (el && !cardsRef.current.includes(el)) {
        cardsRef.current.push(el);
      }
    };
  
    return { addToRefs, animateCards, isTransitioning, setIsTransitioning, timelineRef, cardsRef };
  };